<!-- без view или при visible:false не рендерим ничего — ни круга-обёртки, ни пустого div -->
<div *ngIf="view && view.visible !== false"
     [ngClass]="{'circle': view.wrapper}"
     [style.background-color]="view.wrapper?.color">
  <!-- MatTooltip создаётся только когда тултип задан -->
  <mat-icon *ngIf="view.tooltip as tooltip; else plainIcon"
            [matTooltip]="tooltip"
            [matTooltipClass]="view.tooltipClass || ''"
            [matTooltipPosition]="view.tooltipPosition || 'below'"
            [style.color]="view.color">
    {{ view.name }}
  </mat-icon>
  <ng-template #plainIcon>
    <mat-icon [style.color]="view.color">
      {{ view.name }}
    </mat-icon>
  </ng-template>
</div>
